import request from '@/utils/request'
// import qs from 'qs'
// 员工福利
// 根据时间获取补贴
export const welfareList = (getData) => {
  return request({
    url: '/members-welfare/getWelfareByMonth',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 批量添加补贴数据
export const saveWelfare = (postData) => {
  return request({
    url: '/members-welfare/saveWelfare',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 批量修改补贴数据
export const updateWelfare = (postData) => {
  return request({
    url: '/members-welfare/updateWelfare',
    method: 'post',
    headers: {
      'content-type': 'application/json'
    },
    data: postData
  })
}
// 删除补贴信息
export const deleteById = (getData) => {
  return request({
    url: '/members-welfare/deleteById',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
// 分页查看补贴信息
export const pageList = (getData) => {
  return request({
    url: '/members-welfare/pageList',
    method: 'get',
    headers: {
      'content-type': 'application/json'
    },
    params: getData
  })
}
